export const AuthUrl = process.env.VUE_APP_AUTH_URL;
export const AuthCookieDomainUrl = process.env.VUE_APP_AUTH_COOKIE_DOMAIN;
export const ClientId = process.env.VUE_APP_AUTH_CLIENT_ID;
export const StripeKey = process.env.VUE_APP_STRIPE_KEY;
export const AdminUrl = process.env.VUE_APP_GAME_ADMIN_URL;
